interface ComplaintListResponse {
  payload: {
    count: number;
    result: {
      uuid: string;
      accountUuid: string;
      complaintId: string;
      complaintType: string;
      message: string;
      contact_info: string | null;
      createdAt: string;
      subComplaintType: string;
    }[];
  };
  message: string;
}

interface complaintDetails {
  complaintType: string | null;
  subComplaintType: string | null;
  contact_info: string;
  message: string;
}

async function getComplaintList(
  companyUuid: string,
  type: string,
  page: number,
  limit: number,
  from: string,
  to: string,
  searchQuery: string,
  sort: string
) {
  const response = await fetch(
    `${process.env.REACT_APP_API_URL}hospitality/get-complaint?companyUuid=${companyUuid}&type=${type || 'Sort'}&page=${page}&limit=${limit}&from=${from || ''}&to=${to || ''}&search=${searchQuery}&sort=${sort}`,
    {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${sessionStorage.getItem('token')}`
      }
    }
  );

  if (!response.ok) {
    throw new Error(`Error fetching complaint list: ${response.statusText}`);
  }

  const complaintList: ComplaintListResponse = await response.json();
  return complaintList;
}

async function getEcommVendorComplaintList(
  vendorUuid: string,
  page: number,
  limit: number,
  type: string,
  search: string,
  from: string,
  to: string
) {
  const response = await fetch(
    `${process.env.REACT_APP_API_URL}hospitality/complaint-list?vendorUuid=${vendorUuid}&type=${type}&search=${search}&from=${from}&to=${to}&page=${page}&limit=${limit}`,
    {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${sessionStorage.getItem('token')}`
      }
    }
  );
  const data = await response.json();
  return data;
}

async function createComplaint(companyUuid: string, complaintDetails: complaintDetails) {
  const response = await fetch(
    process.env.REACT_APP_API_URL + `hospitality/create-complaint?companyUuid=${companyUuid}`,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${sessionStorage.getItem('token')}`
      },
      body: JSON.stringify(complaintDetails)
    }
  );
  return response;
}

export { getComplaintList, getEcommVendorComplaintList, createComplaint };
